import { useQuery } from '@tanstack/react-query';
import { equipmentDetailService } from '../services/equipmentDetail.service';

export function useEquipmentDetail(id: string) {
  const equipmentQuery = useQuery({
    queryKey: ['equipment', 'detail', id],
    queryFn: () => equipmentDetailService.getEquipmentDetail(id),
    enabled: !!id,
  });

  const logsQuery = useQuery({
    queryKey: ['equipment', 'logs', id],
    queryFn: () => equipmentDetailService.getUsageLogs(id),
    enabled: !!id,
  });

  return {
    equipment: equipmentQuery.data,
    logs: logsQuery.data || [],
    isLoading: equipmentQuery.isLoading || logsQuery.isLoading,
    isError: equipmentQuery.isError,
  };
}
